import React, { useState } from "react";

import Sidebar from "../../partials/Sidebar";
import Header from "../../partials/Header";
import AccountPanel from "../../partials/settings/AccountPanel";
import SecurityPanel from "../../partials/settings/SecurityPanel";
import ConfigPanel from "../../partials/settings/ConfigPanel";
import useAuth from "../../hooks/useAuth";

function Settings() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Get User Profile
  const { auth } = useAuth();
  const user = auth.user;

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        user={user}
      />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        <Header
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          user={user}
        />

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Content */}
            <div className="bg-white shadow-lg rounded-lg mb-8">
              <div className="flex flex-col space-y-2">
                <AccountPanel user={user} />
                <SecurityPanel user={user} />
              </div>
            </div>
          </div>
        </main>
        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Content */}
            {user.role === "admin" && (
                   <div className="bg-white shadow-lg rounded-lg mb-8">
                   <div className="flex flex-col space-y-2">
                     <ConfigPanel user={user} />
                   </div>
                 </div>
                )}
          
          </div>
        </main>
      </div>
    </div>
  );
}

export default Settings;
